import { render, staticRenderFns } from "./PhishingAwarenessTraining.vue?vue&type=template&id=326edc30&scoped=true&"
import script from "./PhishingAwarenessTraining.vue?vue&type=script&lang=js&"
export * from "./PhishingAwarenessTraining.vue?vue&type=script&lang=js&"
import style0 from "./PhishingAwarenessTraining.vue?vue&type=style&index=0&id=326edc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326edc30",
  null
  
)

export default component.exports